import { connect } from 'react-redux';

import { getExecuteIdsFromJobIds, getUnitsExecutionState } from '../../../reducers/analyticsApp';
import UnitCard from '../../../components/dashboards/cards/UnitCard';
import { cancelRequest } from '../../../api/execute';
import { setRequestCanceled } from '../../../actions/dashboards/dashboards';

const mapStateToProps = (state, { unit }) => {
  const unitsExecution = getUnitsExecutionState(state);
  const executeIds = getExecuteIdsFromJobIds(state);
  const executeId = unitsExecution?.[unit.id]?.executeId;

  return {
    unitsExecution,
    executeId,
    isExecute: unitsExecution?.[unit.id]?.isExecute,
    hasError: unitsExecution?.[unit.id]?.hasError,
    requestCanceled: unitsExecution?.[unit.id]?.requestCanceled,
    cancelButtonDisabled: !executeIds.includes(executeId),
  };
};

const mapDispatchToProps = (dispatch, { unit }) => ({
  onRequestCancel: (executeId) => {
    dispatch(setRequestCanceled(unit.id));
    return dispatch(cancelRequest(executeId));
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onRequestCancel: () => dispatchProps.onRequestCancel(stateProps.executeId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UnitCard);
